var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarNewEmpty = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.205 7.065 7 4.285l-1.205 2.78-2.64.253 2.128 1.77-.71 2.59L7 9.965l2.428 1.715-.71-2.592 2.128-1.769-2.64-.253Zm2.215 2.558L12.732 7.7c.793-.659.478-1.663-.55-1.761L9.23 5.656l-1.3-2.999c-.407-.938-1.45-.939-1.858 0l-1.3 3-2.953.283C.786 6.039.472 7.04 1.27 7.7l2.312 1.922-.858 3.13c-.282 1.028.596 1.648 1.468 1.032l2.81-1.985 2.808 1.985c.876.618 1.75-.004 1.469-1.032l-.858-3.13Z",
    fill: "currentColor"
  })));
};
export default SvgStarNewEmpty;